export function flatten<A>(as: A[][]): A[] {
  return as.reduce((acc: A[], curr: A[]) => [...acc, ...curr], [])
}
